module.exports = __webpack_public_path__ + "static/Busines_Benefied-a18e1f57a4e770fc90590b545fa51faa.png";